import { render, staticRenderFns } from "./LabsMobileSms.vue?vue&type=template&id=75fb1089&"
import script from "./LabsMobileSms.vue?vue&type=script&lang=js&"
export * from "./LabsMobileSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports